// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"UsedSlots-primaryButton-1Hua9d","container":"UsedSlots-container-2sSp1E","box":"UsedSlots-box-1Y0jyB"};